<ion-item
  [button]="button && !loading"
  [detail]="detail"
  [lines]="lines"
  [style.--min-height]="minHeight || null"
  [class.order-item-fixed-height]="!!minHeight"
  [disabled]="disabled"
  [class.order-item-selected]="selected"
  [class.order-item-loading]="loading"
  (click)="onItemClick()"
>
  <span slot="start" class="slot-start">
    @if (loading || syncPending) {
      <ion-spinner
        [name]="loading ? 'crescent' : 'circles'"
        class="slot-start-content"
      ></ion-spinner>
    } @else {
      <ion-avatar
        class="slot-start-content order-item-avatar"
        [attr.aria-label]="getStatusLabel(order.status)"
      >
      </ion-avatar>
    }
  </span>
  <ion-label class="order-item-label">
    <h2 class="order-heading-line">
      @if (showCustomerFirstHeading) {
        @if (customerLabel) {
          <span class="customer-name">{{ customerLabel }}</span>
        }
        @if (customerLabel) {
          <span class="heading-separator" aria-hidden="true">&middot;</span>
        }
        <span class="order-number">{{ orderHeading }}</span>
      } @else {
        <span class="order-number">{{ orderHeading }}</span>
        @if (customerLabel) {
          <span class="heading-separator" aria-hidden="true">&middot;</span>
          <span class="customer-name">{{ customerLabel }}</span>
        }
        @if (order.queueName || (showWaitTime && order.waitTimeMs != null)) {
          <span class="heading-separator" aria-hidden="true">&middot;</span>
          <span class="heading-inline-meta">
            @if (order.queueName) {
              <span class="queue-name">{{ order.queueName }}</span>
            }
            @if (order.queueName && showWaitTime && order.waitTimeMs != null) {
              <span class="meta-separator">&middot;</span>
            }
            @if (showWaitTime && order.waitTimeMs != null) {
              <span class="wait-time wait-time-finalised">{{
                formatWaitTime(order.waitTimeMs)
              }}</span>
            }
          </span>
        }
      }
    </h2>
    @if (showCustomerFirstHeading ? hasMetaLine : policyVersionLabel || appliedPriorityLabel) {
      <p class="order-meta order-meta-policy">
        @if (showCustomerFirstHeading) {
          @if (order.queueName) {
            <span class="queue-name">{{ order.queueName }}</span>
          }
          @if (order.queueName && showWaitTime && order.waitTimeMs != null) {
            <span class="meta-separator">&middot;</span>
          }
          @if (showWaitTime && order.waitTimeMs != null) {
            <span class="wait-time wait-time-finalised">{{
              formatWaitTime(order.waitTimeMs)
            }}</span>
          }
          @if (
            (order.queueName || (showWaitTime && order.waitTimeMs != null)) &&
            (policyVersionLabel || appliedPriorityLabel)
          ) {
            <span class="meta-separator">&middot;</span>
          }
        }
        @if (policyVersionLabel) {
          <span class="policy-version">{{ policyVersionLabel }}</span>
        }
        @if (policyVersionLabel && appliedPriorityLabel) {
          <span class="meta-separator">&middot;</span>
        }
        @if (appliedPriorityLabel) {
          <span class="policy-priority">{{ appliedPriorityLabel }}</span>
        }
      </p>
    }
    @if (showEnqueuedAtRow) {
      <p class="order-meta order-meta-enqueued">
        Enqueued {{ enqueuedAtSmartText }}
      </p>
    }
    @if (!showEndStatusBadge) {
      <span class="order-item-status-sr-only">
        Status: {{ getStatusLabel(order.status) }}
      </span>
    }
  </ion-label>
  <div slot="end" class="order-item-end">
    @if (isBeingCalled) {
      <ion-badge color="tertiary" class="calling-badge"> Calling </ion-badge>
    }
    @if (isSnoozed) {
      <ion-icon name="moon-outline" class="snooze-icon" aria-label="Snoozed"></ion-icon>
    }
    @if (showEndStatusBadge) {
      <ion-badge [color]="getStatusColor(order.status)">
        {{ getStatusLabel(order.status) }}
      </ion-badge>
    }
  </div>
</ion-item>
